"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .unit("U/L")
    .min(100)
    .max(10000)
    .interpretation({ vocab: "htx", code: "ldh" })
    .tag({ vocab: "snomed", code: "250644007" })
    .tag({ vocab: "loinc", code: "2532-0" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "snomed", code: "26958001" })
    .tag({ vocab: "loinc", code: "24325-3" })
    .tag({ vocab: "htx", code: "lab_hepat" });
